import "../components/empty-state.js";

const PATH_MAP: Record<string, string> = {
  "/equipment": "Equipamentos",
  "/inspections": "Inspeções",
  "/ndt": "Ensaios — END",
  "/reports": "Relatórios",
  "/integrity": "Integridade",
  "/engineering": "Engenharia",
  "/management": "Gestão",
  "/documentation": "Documentação",
  "/administration": "Administração",
  "/settings": "Configurações",
  "/studio": "INSPECT IA Studio",
  "/ai-review": "INSPECT IA REVIEW"
};

class PlaceholderPage extends HTMLElement {
  connectedCallback() {
    const path = this.getAttribute("path") || "";
    const moduleName = PATH_MAP[path] || "Módulo";

    this.innerHTML = `
      <div class="page-header">
        <div class="breadcrumb">${moduleName}</div>
        <div class="page-title">${moduleName}</div>
      </div>
      
      <app-empty-state 
        title="${moduleName} Indisponível"
        message="Módulo será disponibilizado em etapa posterior."
      ></app-empty-state>
    `;
  }
}

if (!customElements.get("app-placeholder-page")) {
  customElements.define("app-placeholder-page", PlaceholderPage);
}
